<template>
  <div class="produto-cdlsaude-cancelamento">
    <section class="termo-aceite" v-if="etapa == 'termo'">
      <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
      <Aceite
        :voltar="voltar"
        :action-voltar="true"
        :action-aceite="true"
        @click="salvarAceiteCancelamento"
        @fechar="fechar"
        :file="file"
        :aceite="aceite"
        :loading="loading"
        :strLoading="'Aguarde, salvando o termo'"
      />
      <div class="py-5"></div>
    </section>
    <section v-if="etapa == 'resumo'">
      <div class="content">
        <div class="row">
          <div class="col-6 p-4">
            <Titulo
              title="Cancelamento de Vidas"
              description="Confira os dados da(s) vida(s) que será(ão) cancelada(s)."
            />
          </div>
        </div>
        <DadosVidaResumo
          class="mt-4"
          v-for="(vida, index) in vidasCanceladas"
          :key="index"
          :dados="vida"
        />
        <div class="mt-4 bg-white rounded p-4">
          <div class="row flex-column-reverse flex-md-row">
            <div
              class="col-md-12 col-lg-12 text-center text-md-right mb-3 mb-md-0"
            >
              <p class="mt-4">Valor total do estorno após o cancelamento:</p>
              <div class="">
                <strong class="h3 font-weight-bold text-primary">{{
                  totalValorEstornado | currency
                }}</strong>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5 flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
            <Botao
              title="Voltar"
              @click="etapa = 'cancelar'"
              name-class="btn btn-outline-secondary btn-lg btn-block"
            >
              Voltar
            </Botao>
          </div>
          <div class="col-md-5 col-lg-4">
            <Botao
              title="Próximo"
              @click="etapa = 'termo'"
              name-class="btn btn-cta btn-lg btn-block font-weight-bold"
            >
              PRÓXIMO
            </Botao>
          </div>
        </div>
        <div class="py-5"></div>
      </div>
    </section>
    <section v-if="etapa == 'cancelar'">
      <div class="content">
        <Titulo
          title="Cancelamento de vida"
          description="Solicitação de cancelamento de vida no Plano."
        />

        <div class="mt-4">
          <div class="bg-white p-4 rounded">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="label">
                  {{
                    vidaSel[0].cpF_DEPENDENTE === "" ? "Titular" : "Dependente"
                  }}
                </div>
                <div class="value">{{ vidaSel[0].nome }}</div>
              </div>
              <div>
                <div class="label">Operação</div>
                <div class="value text-danger">CANCELAMENTO</div>
              </div>
              <div>
                <span class="material-icons text-muted"> person_remove </span>
              </div>
            </div>
            <div
              v-if="vidaSel[0].cpF_DEPENDENTE === ''"
              class="alert alert-warning mb-0 mt-3 font-weight-bold"
            >
              ATENÇÃO! Todos os dependentes serão cancelados.
            </div>
          </div>
          <div class="mt-2 bg-white px-4 pt-3 pb-4 rounded">
            <FormulateInput
              type="select"
              placeholder="Informe o motivo do cancelamento:"
              name="motivo"
              v-model="motivo"
              :options="motivosOptions"
              validation="required"
              @change="selecionarMotivo"
            />
            <FormulateInput
              class="mt-3"
              type="textarea"
              v-model="motivoJustificativa"
              placeholder="Vou cancelar pelo seguinte motivo..."
              rows="5"
              v-if="informeMotivo"
            />
          </div>
        </div>
        <div class="row mt-5 flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
            <Botao
              title="Voltar"
              :link="`/produto/cdl-saude-plano/alterarPlano/${vidaSel[0].cpF_TITULAR}`"
              name-class="btn btn-outline-secondary btn-lg btn-block"
            >
              Voltar
            </Botao>
          </div>
          <div class="col-md-5 col-lg-4">
            <Botao
              :class="{ disabled: disabledButton || loading }"
              title="Próximo"
              @click="confirmarCancelamento()"
              name-class="btn btn-cta btn-lg btn-block font-weight-bold"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              CONFIRMAR CANCELAMENTO
            </Botao>
          </div>
        </div>
        <div class="py-5"></div>
      </div>
    </section>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Aceite from "@/components/aceite/Aceite.vue";
import DadosVidaResumo from "@/components/resumo/DadosVidaResumo";
export default {
  name: "CancelarVida",
  components: {
    Titulo,
    Botao,
    Aceite,
    DadosVidaResumo,
  },
  data() {
    return {
      produto: {
        nome: "CDL Saúde",
        id: "CDL Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Troca de Acomodação",
          id: "troca_acomodacao",
        },
      ],
      listaVidas: [],
      vidaSel: [
        {
          cpF_TITULAR: null,
        },
      ],
      motivosOptions: [],
      motivoJustificativa: "",
      informeMotivo: false,
      loading: false,
      etapa: "cancelar",
      checkAceite: false,
      voltar: true,
      motivo: null,
      aceite: "Estou de acordo com o termo acima.",
      file: "",
      cancelVidas: [],
      vidasCanceladas: [],
      totalValorEstornado: 0,
      cpfTitular: null,
    };
  },
  methods: {
    montarDados() {
      this.listaVidas = JSON.parse(sessionStorage.getItem("alterPlano"));
      this.vidaSel = this.listaVidas.filter(
        (el) => el.codvida == this.urlParams.codVida
      );

      this.vidaTitular = this.listaVidas.filter(
        (el) => el.cpF_DEPENDENTE == ""
      );
      this.cpfTitular = this.vidaTitular[0].cpF_TITULAR;

      // Cancela todas as vidas do titular
      if (this.urlParams.codVida === this.vidaTitular[0].codvida) {
        this.listaVidas.forEach((vida) => {
          this.cancelVidas.push({
            codVida: vida.codvida,
            devolveuCartao: false,
          });
        });
        // Cancela so a vida escolhida
      } else {
        this.cancelVidas.push({
          codVida: this.urlParams.codVida,
          devolveuCartao: false,
        });
      }

      this.$http
        .get("api/GestaoSaude/ConsultarMotivosCancelamento")
        .then((response) => {
          response.data.forEach((motivo) => {
            this.motivosOptions.push({
              label: motivo.motCancel.toUpperCase(),
              value: motivo.codMotCancel,
              obs: motivo.reverterSSM,
            });
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "warning",
          });
        });
    },
    selecionarMotivo() {
      const motivo = this.motivosOptions.filter(
        (el) => el.value == this.motivo
      );
      this.informeMotivo = motivo[0].obs;
    },
    async salvarAceiteCancelamento() {
      this.loading = true;
      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }
      this.$http
        .post("/api/Drive/AceitarTermoCancelamento", {
          dtVersao: new Date(),
          dtAceite: new Date(),
          ipOrigem: sessionStorage.ip,
          browserData: navigator.appVersion,
          cpfTitular: this.cpfTitular,
        })
        .then((response) => {
          if (response.status === 200) {
            sessionStorage.removeItem("alterPlano");
            this.$toast.open({
              message: "Termo de cancelamento enviado com sucesso.",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push({
                name: "listavidas",
              });
            }, 2000);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "warning",
          });
        });
    },
    fechar() {
      this.etapa = "resumo";
    },
    confirmarCancelamento() {
      this.loading = true;
      this.vidasCanceladas = [];
      this.$http
        .post("/api/GestaoSaude/SimularCancelamento", {
          todasVidas: this.vidaSel[0].cpF_DEPENDENTE == "" ? true : false,
          codMotCancel: this.motivo,
          codVidaTitular: this.vidaTitular[0].codvida,
          observacao: this.motivoJustificativa,
          vidas: this.cancelVidas,
        })
        .then((response) => {
          if (response.status === 200 && this.informeMotivo) {
            sessionStorage.removeItem("alterPlano");
            this.$toast.open({
              message: "Motivo de cancelamento foi enviado com sucesso",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push({
                name: "listavidas",
              });
            }, 2000);
          } else {
            this.loading = false;
            this.file = `data:application/pdf; base64, ${response.data.file.fileContents}`;
            const simulado = response.data.simulado;

            simulado.vidas.forEach((vida) => {
              const dadosVida = {
                tipoCadastro: "Beneficiário",
                nome: vida.beneficiario,
                plano: {
                  descricao: simulado.plano,
                  valor: vida.estornoPlano,
                  valorOpcionais: vida.estornoOpcionais,
                },
                totalEstornado: vida.estornoPlano + vida.estornoOpcionais,
              };
              this.vidasCanceladas.push(dadosVida);
              this.totalValorEstornado +=
                vida.estornoPlano + vida.estornoOpcionais;
            });
            this.etapa = "resumo";
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "warning",
          });
        });
    },
    confirmarResumo() {
      this.etapa = "termo";
    },
    voltarResumo() {
      this.etapa = "cancelar";
    },
  },
  computed: {
    disabledButton() {
      const motivo = this.motivosOptions.filter(
        (el) => el.value == this.motivo
      );
      if (motivo.length) {
        if (motivo[0].obs) {
          if (this.motivoJustificativa) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    urlParams() {
      return this.$route.params;
    },
  },
  mounted() {
    this.montarDados();
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.produto-cdlsaude-cancelamento /deep/ {
  .material-icons {
    font-size: 38px;
  }
  .label {
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 6px;
  }
  .value {
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    color: #000;
    line-height: 1.4;
  }
  .price-total {
    font-weight: 700;
    font-size: 22px;
  }
  @import "@/assets/scss/_vue-formulate.scss";

  .formulate-input {
    &[data-classification="select"] {
      select {
        padding: 10px;
        background: $dark-100;
        border: none;
        color: $dark;
        border-radius: 4px;
        line-height: 1.4;
      }
    }
  }
}
</style>
